import { styled } from '@compiled/react';
import React from 'react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledMainDiv = styled.div<{ isTitleCenterAligned?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'@keyframes show': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'0%': {
			opacity: 0,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'100%': {
			opacity: 1,
		},
	},
	font: token('font.body.small'),
	color: token('color.text.subtle'),
	/* update next/packages/content-title/src/ContentTitlePlaceholder.js when this changes */
	margin: `${token('space.250')} 0 ${token('space.250')} 0`,
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	textAlign: (p) => (p.isTitleCenterAligned ? 'center' : 'inherit'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LivePagesBylineStyledMainDiv = styled(StyledMainDiv)<{ hasFixedHeight?: boolean }>({
	alignItems: 'center',
	margin: token('space.0'),
	flexGrow: 1,
	zIndex: '100',
	whiteSpace: 'nowrap',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	height: (props) => (!!props.hasFixedHeight ? '32px' : 'initial'), // fixed height value MUST match bylineStyles in LivePagesByLinePlaceholderComponent.tsx
});

// Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */
const BylineStyledMainDivSingleLineWrapper = ({ isExpanded, children, ...props }) => {
	return <LivePagesBylineStyledMainDiv {...props}>{children}</LivePagesBylineStyledMainDiv>;
};
/* eslint-enable @typescript-eslint/no-unused-vars */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BylineStyledMainDivSingleLine = styled(BylineStyledMainDivSingleLineWrapper)<{
	isExpanded?: boolean;
}>({
	width: '100%',
	// relative is necessary for widthobserver to detect this as the parent and provide width of content area
	position: 'relative',
	// zindex causes the byline to be above the space nav and there doesnt seem to be an apparent need for it
	zIndex: 'auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'[data-testid="byline-single-line"]': {
		// 1px shift to prevent jerkiness when expanding the apps
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
		marginTop: (props) => (props.isExpanded ? '1px' : '0'),
		// Prevent height of div from being changed due to marginTop
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
		marginBottom: (props) => (props.isExpanded ? '-1px' : '0'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledTextDiv = styled.div<{ hasBadgeStylePageOwnerBylineItem?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	margin: (props) => (!!props.hasBadgeStylePageOwnerBylineItem ? 0 : `0 0 0 ${token('space.100')}`),
	/* IE11 */
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	a: {
		textDecoration: 'none',
		color: token('color.link'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'a:focus, a:hover, a:visited, a:active': {
		color: token('color.link.pressed'),
		textDecoration: 'underline',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BylineStyledTextDiv = styled(StyledTextDiv)({
	display: 'flex',
	alignItems: 'center',
	marginTop: token('space.025'),
});
